import React, {useState} from 'react';
import {AuthLayout} from "../../core/layout/AuthLayout";
import {useSelector} from "react-redux";
import {selectUser} from "../../core/reducer/auth/authSlice";
import WarningMsg from "../../shared/ui/warningMsg/WarningMsg";


export function Home() {
    const user = useSelector(selectUser)
    const [haveLimit, setHaveLimit] = useState(false)
    
    return (
        <AuthLayout>
            <div className="row">
                <div className="col-sm-12 col-md-8 col-lg-6 col-xl-4 mt-5">
                    <div className={'d-flex gap-4 align-items-center'}>
                        <img src="./assets/welcome-logo.png" alt=""/>
                        <div className={'py-5'}>
                            <h1>Ciao, {user?.name} {user?.surname}</h1>
                            <h6 className={'text-muted'}>Procedi selezionando la voce di menu in alto scegliendo
                                l’opzione desiderata!</h6>
                            {/*<p>Sei in possesso di una licenza PRO fino al 12/12/2027</p>*/}
                        </div>
                    </div>
                    <div>
                        {haveLimit && <WarningMsg
                            msg={`ATTENZIONE! Hai un numero di dipendenti maggiore degli slot disponibili. Aggiorna il piano aumentando il limite per continuare con le operazioni di gestione, grazie.`}/>}
                    </div>
                </div>
            </div>
        </AuthLayout>
    );
}
